export default "__VITE_ASSET__ChzVZRQQ__"